export const enum Tasks {
  missedShots = '0',
  timeFirstShots = '1',
  timeSecondShots = '2',
}
